import { Asset } from "./assets/Asset";
import { Attachment } from "./Attachment";
import { Drawing } from "./drawings/Drawing";
import { Finding } from "./Findings";
import { is_in_range } from "./Geometry";
import { MapFeature } from "./MapFeature";
import { WorkorderMapFeature } from "./workorders/Workorder";

export class MapFeaturesCollection {

    private flat_map: MapFeature[] = [];
    public static get empty() {
        return new MapFeaturesCollection();
    }
    private constructor() {}



    public add_features(values: MapFeature[]): MapFeaturesCollection {
        this.flat_map = this.flat_map.concat(values);
        return this;
    }

    public get workorders(): WorkorderMapFeature[]
    {
    
        let r: MapFeature[] = this.flat_map.filter((val: MapFeature) => {
            return (val instanceof WorkorderMapFeature);

        });

        return r.map((val: MapFeature) => {
            return val as WorkorderMapFeature;
        });
    }

    public get findings(): Finding[]
    {
    
        let r: MapFeature[] = this.flat_map.filter((val: MapFeature) => {
            return (val instanceof Finding);

        });

        return r.map((val: MapFeature) => {
            return val as Finding;
        });
    }

    public get attachments(): Attachment[]
    {
    
        let r: MapFeature[] = this.flat_map.filter((val: MapFeature) => {
            return (val instanceof Attachment);

        });

        return r.map((val: MapFeature) => {
            return val as Attachment;
        });
    }

    
    public get assets(): Asset[]
    {
    
        let r: MapFeature[] = this.flat_map.filter((val: MapFeature) => {
            return (val instanceof Asset);

        });

        return r.map((val: MapFeature) => {
            return val as Asset;
        });
    }


    public translate(drawing: Drawing, decluster: boolean) {
        this.flat_map.forEach((mf: MapFeature) => {
            mf.translate(drawing);
        });
        if (decluster) {
            this.decluster();
        }
    }

    private decluster() {
        let minimum_distance = 50;
        let nudge_max = 100;

        let declusterCore = () => {
            this.flat_map.forEach((lhs: MapFeature) => {
                if (!lhs.is_valid) {
                    return;
                }
                this.flat_map.forEach((rhs: MapFeature) => {
                    if (!rhs.is_valid) {
                        return;
                    }
                    if (lhs.generic_id == rhs.generic_id) {
                        return;
                    }
                    let lhs_cord = lhs.adj_cluster_coords;
                    let rhs_cord = rhs.adj_cluster_coords;
                    if (is_in_range(lhs_cord, rhs_cord, minimum_distance)) {
                        lhs.nudge_apart(rhs, minimum_distance, nudge_max);
                    }
                });
            });
        };

        // run the decluster algorithm multiple times
        declusterCore();
        declusterCore();
        declusterCore();
    }

    public get as_array(): MapFeature[] {
        return this.flat_map.concat([]); // causes a deep copy of the array
    }
}
